import AdminLayout from '../../layouts/AdminLayout';

const PaymentView = () => {
  return <AdminLayout>Payment View</AdminLayout>;
};

export default PaymentView;
